<div class="h-full w-full flex flex-col justify-start items-stretch">
    <mat-toolbar class="bg-(--mat-sys-primary-container)! text-(--mat-sys-on-primary-container)! shrink-0">
        <div class="text-3xl">Certificate Maker</div></mat-toolbar
    >
    <div class="flex justify-start items-stretch gap-10 grow p-5">
        <div class="grow flex flex-col justify-center items-center">
            <div id="samplebox" class="relative">
                <img id="certsample" src="images/certsample2.jpg" class="w-[450px] max-w-[450px]" height="334" />
                <div id="sampteach" class="text-[10pt] absolute top-[305px] left-[85px] text-black font-[JCorsiva]">
                    {{ certForm.controls.TeacherName.value }}
                </div>
                <div
                    id="sampname"
                    class="font-bold text-[18pt] absolute top-[118px] left-0 w-full text-center text-black font-[JGeorgia]"
                >
                    Some Student
                </div>
                <div
                    id="sampschool"
                    class="font-bold text-[18pt] absolute top-[175px] left-0 w-full text-center text-black font-[JGeorgia]"
                >
                    {{ certForm.controls.SchoolName.value }}
                </div>
                <div id="sampachieve1" class="absolute top-[212px] left-[97.5px] text-black font-[JCorsiva]">
                    {{ certForm.controls.Cause1.value }}
                </div>
                @if (certForm.controls.Cause2.value) {
                    <div id="sampachieve2" class="absolute top-[235px] left-[112.5px] text-black font-[JCorsiva]">
                        {{ certForm.controls.Cause2.value }}
                    </div>
                }
                @if (sGraphic()) {
                    <img id="graphic1" class="absolute top-[270px] left-[10px] w-[60px] h-[60px]" [src]="'images/' + sGraphic()" />
                    <img id="graphic2" class="absolute top-[270px] left-[380px] w-[60px] h-[60px]" [src]="'images/' + sGraphic()" />
                }
            </div>
        </div>
        <div class="grow">
            <h1 class="text-2xl">School Certificate Maker</h1>
            <p class="mt-2">
                Welcome to the School Certificate Maker Program! This program is designed to assist in creating convenient awards for
                students at the end of a school year, or any time you wish to recognize someone for outstanding achievement. Your
                awards will be created and provided to you in the form of a PDF (Adobe Portable Document Format) file. In order to view
                these, your computer must have the Adobe Acrobat Reader installed. Please visit
                <a href="https://www.adobe.com/go/EN_US-H-GET-READER" target="_blank"> Adobe Acrobat Reader Download</a> (External
                site) to download the free reader.
            </p>
            <p class="my-4">
                To create the PDF file containing all of the certificates you wish, please complete the following steps:
            </p>
            <ul class="list-disc">
                <li>Fill in the boxes for the teacher's name/title and school's name.</li>
                <li>
                    Fill in the student box with the names of all students who will be receiving an award. You may enter a single name,
                    or multiple names. Be sure each name is listed on a separate line. You may enter names in either &lt;First Last&gt;
                    or &lt;Last, First&gt; format.
                </li>
                <li>
                    Select whether you prefer music graphics, art graphics, or no graphics by choosing the appropriate radio option.
                    <u>Note:</u> All certificates must use the same graphics.
                </li>
                <li>
                    Fill in the two lines of text for the specific recognition you would like to provide. <u>Note:</u> Due to
                    certificate spacing, this text should be kept to a maximum of 60 letters or less on each line.
                </li>
                <li>Verify your information is entered correctly, then click the "Submit" button below the box.</li>
            </ul>

            <div id="formbox" class="mt-4 flex flex-col justify-start items-stretch gap-2" [formGroup]="certForm" #group="ngForm">
                <div class="flex justify-start items-center gap-4">
                    <span>Teacher Name &amp; Title:</span>
                    <mat-form-field appearance="outline" class="grow">
                        <input matInput type="text" formControlName="TeacherName" #teacherctrl />
                    </mat-form-field>
                </div>
                <div class="flex justify-start items-center gap-4">
                    <span>School Name:</span>
                    <mat-form-field appearance="outline" class="grow">
                        <input matInput type="text" formControlName="SchoolName" />
                        <mat-hint align="start">(Max 32 characters)</mat-hint>
                        <mat-hint align="end">{{ certForm.controls.SchoolName.value.length }}/32</mat-hint>
                    </mat-form-field>
                </div>
                <div class="flex justify-start items-center gap-4">
                    <span>Graphics Choice:</span>
                    <mat-radio-group class="flex justify-start items-center gap-3" formControlName="GraphicsChoice">
                        <mat-radio-button value="music">Music</mat-radio-button>
                        <mat-radio-button value="art">Art</mat-radio-button>
                        <mat-radio-button value="none">No Graphics</mat-radio-button>
                    </mat-radio-group>
                </div>
                <div class="flex justify-start items-center gap-4">
                    <span>Recognition Line 1:</span>
                    <mat-form-field appearance="outline" class="grow">
                        <input matInput type="text" formControlName="Cause1" />
                        <mat-hint align="start">(Max 60 characters)</mat-hint>
                        <mat-hint align="end">{{ certForm.controls.Cause1.value.length }}/60</mat-hint>
                    </mat-form-field>
                </div>
                <div class="flex justify-start items-center gap-4">
                    <span>Recognition Line 2:</span>
                    <mat-form-field appearance="outline" class="grow">
                        <input matInput type="text" formControlName="Cause2" />
                        <mat-hint align="start">(Max 60 characters)</mat-hint>
                        <mat-hint align="end">{{ certForm.controls.Cause2.value.length }}/60</mat-hint>
                    </mat-form-field>
                </div>
                <div class="flex justify-start items-center gap-4">
                    <span>Student Names:</span>
                    <mat-form-field appearance="outline" class="grow">
                        <textarea rows="5" matInput formControlName="Students"></textarea>
                    </mat-form-field>
                </div>
                <div class="flex justify-start items-center gap-4">
                    <button type="button" mat-flat-button (click)="downloadCertificate()">Submit</button>
                    <button type="button" class="cancel-button" mat-flat-button (click)="clear()">Clear</button>
                </div>
            </div>
        </div>
    </div>
</div>
